import './TableRow.scss';

import cn from 'classnames';
import React from 'react';

import { TableRowDefaultProps, TableRowPropTypes } from './TableRow.proptypes';

const TableRow = ({ columns, tabIndex, isHeader, onSelect }) => {
  const handleSelect = () => {
    onSelect();
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      handleSelect();
    }
  };

  const buttonProps = !isHeader
    ? {
        role: 'button',
        tabIndex,
        onClick: onSelect,
        onKeyDown: handleKeyDown,
      }
    : {};

  return (
    <div
      className={cn('scan-self-service-table-row', {
        'scan-self-service-table-row--header': isHeader,
      })}
      data-qa-id="scan-self-service-table-row"
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...buttonProps}
    >
      {columns.map(({ label, type }) => (
        <div
          key={type}
          className={cn(
            'scan-self-service-table-row__col',
            `scan-self-service-table-row__col-${type}`,
            {
              'scan-self-service-table-row__col--header': isHeader,
              [`scan-self-service-table-row__col-${type}--header`]: isHeader,
            },
          )}
          title={label}
          data-qa-id="column"
        >
          {label}
        </div>
      ))}
    </div>
  );
};

TableRow.defaultProps = {
  ...TableRowDefaultProps,
};

TableRow.propTypes = {
  ...TableRowPropTypes,
};

export default TableRow;
